var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-container"},[_c('div',{staticClass:"news-image",style:(_vm.backgroundImage)},[_c('div',{staticClass:"news-date"},[_vm._v(" "+_vm._s(_vm._f("ddmmYYYY")(_vm.news.datePublished))+" ")])]),_c('div',{staticClass:"news-content"},[_c('router-link',{staticClass:"link",attrs:{"to":{
       name: 'articlePage',
        params: {
          articleUrl: _vm.news.url,
        },
      }}},[_c('h4',{staticClass:"news-title"},[_vm._v(" "+_vm._s(_vm.getTranslatedContent('title', _vm.news.content))+" ")])]),_c('p',{staticClass:"news-text",domProps:{"innerHTML":_vm._f("truncate")(_vm.description(_vm.news.content),_vm.truncationLimit)}}),_c('router-link',{staticClass:"link",attrs:{"to":{
        name: 'articlePage',
        params: {
          articleUrl: _vm.news.url,
        },
      }}},[_c('p',{staticClass:"read-more"},[_vm._v(" "+_vm._s(_vm.getTranslatedContent('READ_MORE'))+" ")])])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }